import { useState } from 'react';
import { ArrowDownTrayIcon, DocumentArrowDownIcon, TableCellsIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import { toast } from 'react-hot-toast';

const getTodayIso = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ExportButtons = ({ tipo = 'lancamentos', filtros = {}, compact = false }) => {
  const [exportando, setExportando] = useState(false);

  const exportarPDF = async () => {
    setExportando(true);
    try {
      const response = await axios.get(`/api/exportar/pdf/${tipo}`, {
        params: filtros,
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      const nomeArquivo = tipo === 'dre' 
        ? `dre_${filtros.data_inicio || 'periodo'}_${filtros.data_fim || 'atual'}.pdf`
        : `${tipo}_exportacao.pdf`;
      
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('PDF gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar PDF:', error);
      toast.error('Erro ao gerar PDF');
    } finally {
      setExportando(false);
    }
  };

  const exportarExcel = async () => {
    setExportando(true);
    try {
      const response = await axios.get(`/api/exportar/excel/${tipo}`, {
        params: filtros,
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const todayIso = getTodayIso();
      
      const nomeArquivo = tipo === 'lancamentos'
        ? `lancamentos_${todayIso}.xlsx`
        : `${tipo}_${todayIso}.xlsx`;
      
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('Excel gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao exportar Excel:', error);
      toast.error('Erro ao gerar Excel');
    } finally {
      setExportando(false);
    }
  };

  const buttonClassName = compact
    ? 'inline-flex items-center rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm transition hover:border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
    : 'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const pdfClassName = compact
    ? buttonClassName
    : `${buttonClassName} bg-danger-600 hover:bg-danger-700 focus:ring-danger-500`;

  const excelClassName = compact
    ? buttonClassName
    : `${buttonClassName} bg-success-600 hover:bg-success-700 focus:ring-success-500`;

  const allClassName = compact
    ? buttonClassName
    : `${buttonClassName} bg-primary-600 hover:bg-primary-700 focus:ring-primary-500`;

  return (
    <div className={`flex flex-wrap ${compact ? 'gap-2' : 'gap-3'}`}>
      <button
        onClick={exportarPDF}
        disabled={exportando}
        className={pdfClassName}
      >
        <DocumentArrowDownIcon className={`${compact ? 'h-4 w-4 mr-1.5' : 'h-5 w-5 mr-2'}`} />
        {exportando ? 'Gerando...' : (compact ? 'PDF' : 'Exportar PDF')}
      </button>
      
      <button
        onClick={exportarExcel}
        disabled={exportando}
        className={excelClassName}
      >
        <TableCellsIcon className={`${compact ? 'h-4 w-4 mr-1.5' : 'h-5 w-5 mr-2'}`} />
        {exportando ? 'Gerando...' : (compact ? 'Excel' : 'Exportar Excel')}
      </button>
      
      <button
        onClick={() => {
          exportarPDF();
          exportarExcel();
        }}
        disabled={exportando}
        className={allClassName}
      >
        <ArrowDownTrayIcon className={`${compact ? 'h-4 w-4 mr-1.5' : 'h-5 w-5 mr-2'}`} />
        {exportando ? 'Exportando...' : (compact ? 'Todos' : 'Exportar Todos')}
      </button>
    </div>
  );
};

export default ExportButtons;
